import { Auth0Logo as Auth0LogoLight, Auth0LogoDark } from '@ankr.com/ui';
import { useTheme } from '@mui/material';

import { isLightTheme } from 'uiKit/Theme/themeUtils';

export const Auth0Logo = (props: Parameters<typeof Auth0LogoLight>[0]) => {
  const theme = useTheme();

  if (isLightTheme(theme)) {
    return <Auth0LogoLight {...props} />;
  }

  return <Auth0LogoDark {...props} />;
};
